import React from "react";
import { Theme } from "../../theme";

export const AlertIcon = ({ fill, ...props }) => {
    return (
        <svg id="Icon-Alert" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
            <path
                id="Icon-Alert-2"
                data-name="Icon-Alert"
                d="M681.25,370.25a12,12,0,1,0,12,12A12,12,0,0,0,681.25,370.25Zm0,21.659a9.659,9.659,0,1,1,9.659-9.659A9.659,9.659,0,0,1,681.25,391.909Zm-1.938-6.135h3.874V389.1h-3.874Zm-.176-10.376h4.229v1.664l-1.135,7.579h-1.959l-1.135-7.579Z"
                transform="translate(-669.25 -370.25)"
                fill={fill ? fill : Theme.colors.blue}
            />
        </svg>
    );
};
